import { DayOfWeek } from '../../types/day-of-week';
export const getStartOfWeek = (startWeekOnSunday) => {
    const today = new Date(Date.now());
    let todayDayOfWeek = today.getDay();
    // Dealing with Sunday (which has a value of 0) when it is not the start of the week (so needs to have the value after Saturday).
    if (!startWeekOnSunday && todayDayOfWeek === DayOfWeek.Sunday) {
        todayDayOfWeek = DayOfWeek.Saturday + 1;
    }
    const startOfWeek = startWeekOnSunday ? DayOfWeek.Sunday : DayOfWeek.Monday;
    return new Date(today.getFullYear(), today.getMonth(), today.getDate() - todayDayOfWeek + startOfWeek);
};
